import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { mergeProps as i } from "@base-ui/react/merge-props";
import { useRender as a } from "@base-ui/react/use-render";
import { Drawer as o } from "@base-ui/react/drawer";
//#region src/bottom-drawer/index.tsx
var s = (e) => /* @__PURE__ */ n(o.Root, {
	swipeDirection: "down",
	...e
}), c = t((e, t) => /* @__PURE__ */ n(o.Portal, {
	ref: t,
	...e
})), l = t((e, t) => /* @__PURE__ */ n(o.Trigger, {
	ref: t,
	"data-slot": "bottom-drawer-trigger",
	"data-testid": "bottom-drawer-trigger",
	...e
})), u = t((e, t) => /* @__PURE__ */ n(o.Close, {
	ref: t,
	"data-slot": "bottom-drawer-close",
	"data-testid": "bottom-drawer-close",
	...e
})), d = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Backdrop, {
	forceRender: !0,
	ref: i,
	className: e("bg-system-secondary-950/25 fixed inset-0 z-50 min-h-dvh backdrop-blur-sm", "opacity-[calc(1-var(--drawer-swipe-progress,0))]", "transition-opacity duration-450 ease-[cubic-bezier(0.32,0.72,0,1)]", "data-ending-style:opacity-0 data-starting-style:opacity-0", "data-swiping:duration-0", "data-ending-style:duration-[calc(var(--drawer-swipe-strength,1)*400ms)]", "supports-[-webkit-touch-callout:none]:absolute", t),
	"data-slot": "bottom-drawer-backdrop",
	"data-testid": "bottom-drawer-backdrop",
	...r
})), f = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Viewport, {
	ref: i,
	className: e("fixed inset-0 z-50 flex items-end justify-center", t),
	"data-slot": "bottom-drawer-viewport",
	"data-testid": "bottom-drawer-viewport",
	...r
})), p = t(({ className: t, children: r, render: o, ...s }, c) => {
	let l = {
		className: e("flex w-full shrink-0 items-start justify-center overflow-hidden pt-2.5 pb-1.5", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/bottom-drawer-popup:opacity-0 group-data-nested-drawer-swiping/bottom-drawer-popup:opacity-100", t),
		"data-slot": "bottom-drawer-handle",
		"data-testid": "bottom-drawer-handle",
		ref: c,
		children: r ?? /* @__PURE__ */ n("span", {
			"aria-hidden": !0,
			className: "bg-border-300 h-1 w-10 shrink-0 rounded-[2px]",
			"data-slot": "bottom-drawer-handle-bar",
			"data-testid": "bottom-drawer-handle-bar"
		})
	};
	return a({
		defaultTagName: "div",
		props: i(l, s),
		render: o
	});
}), m = t(({ className: t, children: i, showHandle: a = !0, backdropProps: s, portalProps: l, viewportProps: u, ...m }, h) => /* @__PURE__ */ r(c, {
	...l,
	children: [/* @__PURE__ */ n(d, { ...s }), /* @__PURE__ */ n(f, {
		...u,
		children: /* @__PURE__ */ r(o.Popup, {
			ref: h,
			className: e("group/bottom-drawer-popup bg-bg-primary text-text-primary relative flex max-h-[90dvh] w-full min-w-0 flex-col overflow-hidden rounded-t-[20px] outline-none", "touch-auto will-change-transform", "[--bleed:3rem] [--peek:1rem]", "[--stack-progress:clamp(0,var(--drawer-swipe-progress,0),1)]", "[--stack-step:0.05]", "[--stack-peek-offset:max(0px,calc((var(--nested-drawers,0)-var(--stack-progress))*var(--peek)))]", "[--stack-scale-base:max(0,calc(1-(var(--nested-drawers,0)*var(--stack-step))))]", "[--stack-scale:calc(var(--stack-scale-base)+(var(--stack-step)*var(--stack-progress)))]", "[--stack-shrink:calc(1-var(--stack-scale))]", "[--stack-height:max(0px,calc(var(--drawer-frontmost-height,var(--drawer-height,0px))-var(--bleed)))]", "[--translate-y:calc(var(--drawer-swipe-movement-y,0px)-var(--stack-peek-offset)-(var(--stack-shrink)*var(--stack-height)))]", "origin-[50%_calc(100%-var(--bleed))]", "transform-[translateY(calc(var(--drawer-snap-point-offset,0px)+var(--translate-y)))_scale(var(--stack-scale))]", "h-(--drawer-height,auto)", "transition-[transform,height] duration-450 ease-[cubic-bezier(0.32,0.72,0,1)]", "data-nested-drawer-swiping:duration-0 data-swiping:duration-0 data-swiping:select-none", "data-starting-style:transform-[translateY(calc(100%+2px))_scale(1)]", "data-ending-style:transform-[translateY(calc(100%+2px))_scale(1)]", "data-ending-style:duration-[calc(var(--drawer-swipe-strength,1)*400ms)]", "data-nested-drawer-open:h-[calc(var(--stack-height)+var(--bleed))]", "after:pointer-events-none after:absolute after:inset-0 after:bg-transparent after:transition-[background-color] after:duration-450 after:ease-[cubic-bezier(0.32,0.72,0,1)] after:content-['']", "data-nested-drawer-open:after:bg-black/5", t),
			"data-slot": "bottom-drawer-popup",
			"data-testid": "bottom-drawer-popup",
			...m,
			children: [a && /* @__PURE__ */ n(p, {}), i]
		})
	})]
})), h = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Content, {
	ref: i,
	className: e("flex min-h-0 w-full shrink flex-col gap-4 overflow-y-auto overscroll-contain p-4 *:shrink-0", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/bottom-drawer-popup:opacity-0 group-data-nested-drawer-swiping/bottom-drawer-popup:opacity-100", t),
	"data-slot": "bottom-drawer-content",
	"data-testid": "bottom-drawer-content",
	...r
})), g = t(({ className: t, render: n, ...r }, o) => {
	let s = {
		className: e("border-border-100 flex w-full shrink-0 flex-col items-start border-b p-4", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/bottom-drawer-popup:opacity-0 group-data-nested-drawer-swiping/bottom-drawer-popup:opacity-100", t),
		"data-slot": "bottom-drawer-header",
		"data-testid": "bottom-drawer-header",
		ref: o
	};
	return a({
		defaultTagName: "div",
		props: i(s, r),
		render: n
	});
}), _ = t(({ className: t, elevated: n = !1, render: r, ...o }, s) => {
	let c = {
		className: e("bg-bg-primary flex w-full shrink-0 items-center justify-center p-4", n ? "shadow-[0_0_15px_rgba(15,23,42,0.05)]" : "border-border-100 border-t", "transition-opacity duration-300 ease-[cubic-bezier(0.45,1.005,0,1.005)] group-data-nested-drawer-open/bottom-drawer-popup:opacity-0 group-data-nested-drawer-swiping/bottom-drawer-popup:opacity-100", t),
		"data-slot": "bottom-drawer-footer",
		"data-testid": "bottom-drawer-footer",
		ref: s
	};
	return a({
		defaultTagName: "div",
		props: i(c, o),
		render: r
	});
}), v = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Title, {
	ref: i,
	className: e("text-text-primary text-2xl font-semibold", t),
	"data-slot": "bottom-drawer-title",
	"data-testid": "bottom-drawer-title",
	...r
})), y = t(({ className: t, ...r }, i) => /* @__PURE__ */ n(o.Description, {
	ref: i,
	className: e("text-text-tertiary text-base", t),
	"data-slot": "bottom-drawer-description",
	"data-testid": "bottom-drawer-description",
	...r
}));
s.displayName = "BottomDrawer.Root", c.displayName = "BottomDrawer.Portal", l.displayName = "BottomDrawer.Trigger", u.displayName = "BottomDrawer.Close", d.displayName = "BottomDrawer.Backdrop", f.displayName = "BottomDrawer.Viewport", m.displayName = "BottomDrawer.Popup", p.displayName = "BottomDrawer.Handle", h.displayName = "BottomDrawer.Content", g.displayName = "BottomDrawer.Header", _.displayName = "BottomDrawer.Footer", v.displayName = "BottomDrawer.Title", y.displayName = "BottomDrawer.Description";
var b = {
	Root: s,
	Portal: c,
	Trigger: l,
	Close: u,
	Backdrop: d,
	Viewport: f,
	Popup: m,
	Handle: p,
	Content: h,
	Header: g,
	Footer: _,
	Title: v,
	Description: y,
	createHandle: o.createHandle
};
//#endregion
export { b as BottomDrawer };
